import React, { useEffect, useState } from 'react';
import { Panel } from 'rsuite';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getFetched } from '../../../../redux/Guest/selectors/file';
import { fetchGuestFiles } from '../../../../redux/sagas/routines';
import FilesList from '../../../../containers/guest/FileList';
import FileSearch from '../../../../containers/guest/FileSearch';
import FileUpload from '../../../../components/guest/FileUpload';

const FilesSection = ({ guestId, ...props }) => {
  const dispatch = useDispatch();
  const isFetched = useSelector(getFetched);
  const [showForm, setShowForm] = useState(false);

  const handleHideForm = () => {
    setShowForm(false);
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  useEffect(
    () => {
      if (!guestId || isFetched) return;
      dispatch(fetchGuestFiles({ guestId }));
    },
    [guestId]
  );

  return (
    <Panel {...props}>
      <Panel bordered style={{ marginBottom: 10, minHeight: 80 }}>
        <FileSearch guestId={guestId} placeholder="Search by name" />
        <FileUpload
          guestId={guestId}
          showForm={showForm}
          onHideForm={handleHideForm}
          onShowForm={handleShowForm}
        />
      </Panel>
      <FilesList guestId={guestId} />
    </Panel>
  );
};

FilesSection.propTypes = {
  guestId: PropTypes.number.isRequired
};

export default FilesSection;
